import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConnectionService } from './connection.service';
import { ConfigService } from './endpoint.config.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { skip } from 'rxjs';
import { take } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class LocationService extends ConnectionService {
  currentLocationId: any;
  url: string;
  constructor(http: HttpClient, private configs: ConfigService, private toaster: ToastrService) {

    super(http);

    if (this.currentLocationId == undefined && sessionStorage.getItem("company") != undefined)
      this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;

  }
  makeUnique(arr) {
    var uniqueArray = [];
    arr.forEach(function (element) {
      if (uniqueArray.indexOf(element) == -1) {
        uniqueArray.push(element);
      }
    })
    return uniqueArray;
  }
  getLocationRoles(sucFun, errFun) {
    this.CallApi("get", this.configs.getAppApiUrl("GET_ROLES").replace("{{currentLocationId}}", this.currentLocationId), {}, null, (res) => {
      sucFun(res)
    }, (err) => {
      errFun(err)
    })

  }
  getUserCompaniesAndLocations(sucFun, errFun) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json')
    this.CallApi("get", this.configs.getAppApiUrl("LOCATIONS"), {}, headers, (res) => {
      var resp = JSON.parse(JSON.stringify(res)) as any[];
      var BranchCompanyIds = [];
      var companies = [];
      for (var i = 0; i < resp.length; i++) {
        BranchCompanyIds.push(resp[i].Location.BranchCompanyId);
      }
      BranchCompanyIds = this.makeUnique(BranchCompanyIds);
      BranchCompanyIds.forEach((id, index) => {
        companies.push({
          "BranchCompanyCountryCode": '',
          "BranchCompanyCountryName": '',
          "BranchCurrencyCode": '',
          "BranchCompanyId": id,
          "UserLocationId": '',
          "BranchCompanyName": '',
          "Branches": []
        });

        resp.filter((x) => {
          if (x.Location.BranchCompanyId == id && x.Active) {
            companies[index].BranchCompanyName = x.Location.BranchCompanyName;
            companies[index].UserLocationId = x.UserLocationId;
            companies[index].BranchCompanyCountryCode = x.Location.BranchCompanyCountryCode;
            companies[index].BranchCompanyCountryName = x.Location.BranchCompanyCountryName;
            companies[index].BranchCurrencyCode = x.Location.BranchCurrencyCode;
            companies[index].BranchCompanyDefaultWeightUnit = x.Location.BranchCompanyDefaultWeightUnit;
            companies[index].Branches.push({
              "BranchDisplayName": x.Location.BranchDisplayName,
              "BranchId": x.Location.BranchId,
              "BranchCompanyCode": x.Location.BranchCompanyCode,
              "BranchCity": x.Location.BranchCity,
              "BranchPostCode": x.Location.BranchPostCode,
              "BranchState": x.Location.BranchState,
              "Roles": x.Roles,
              "UserLocationId": x.UserLocationId,
              "Active":x.Active
            });
          }
        })
      })

      sucFun(companies);
      this.currentLocationId = sessionStorage.getItem("company") ? JSON.parse(sessionStorage.getItem("company")).UserLocationId :  '';

    }, (err) => { errFun(err) });

  }
  getLocationDetails(sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;

    this.CallApi("get", this.configs.getAppApiUrl("GET_LOCATION_DETAILS").replace("{{currentLocationId}}", this.currentLocationId), {}, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }

  saveLocationDetails(location, sucFun, errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("put", this.configs.getAppApiUrl("SAVE_LOCATION_DETAILS").replace("{{currentLocationId}}", this.currentLocationId), location, null,
      (res) => {
        sucFun()
      },
      (err) => {
        try {
          
          errFun(err.error)
        }
        finally {

        }
      }
    );
  }

  getLocationSettings() {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    this.CallApi("get", this.configs.getAppApiUrl("GET_LOCATION_SETTINGS").replace("{{currentLocationId}}", this.currentLocationId), {}, null, (res) => {
      sessionStorage.setItem("branchSettings", JSON.stringify(res))
    }, (err) => {
    });
  }
  getPickupBranches(companyCode,sucFun,errFun) {
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endpoint = this.configs.getAppApiUrl("GET_PICKUP_BRANCH").replace("{{currentLocationId}}", this.currentLocationId)
    this.CallApi("get", endpoint, {
      companyCode: companyCode,
      skip: 0,
      take: 1000
    }, null,
      (res) => {
        sucFun(res)
      },
      (err) => { errFun(err) })

  }

  getBase64(FileUrl,sucFun,errFun){
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endpoint = this.configs.getAppApiUrl("GET_Base64").replace("{{currentLocationId}}", this.currentLocationId)
    this.CallApi("get", endpoint, {
      FileUrl:FileUrl,
      skip: 0,
      take: 1000
    }, null,
      (res) => {
        sucFun(res)
      },
      (err) => { errFun(err) })
  }

  getPackagingPrices(sucFun,errFun){
    this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endpoint = this.configs.getAppApiUrl("GET_PACKAGING_PRICES").replace("{{currentLocationId}}", this.currentLocationId)
    this.CallApi("get", endpoint, {}, null,
      (res) => {
        sucFun(res)
      },
      (err) => { errFun(err) })
  }

  addPackagingPrices(data,sucFun,errFun){
    var endpoint = this.configs.getAppApiUrl("ADD_PACKAGING_PRICES").replace("{{currentLocationId}}", this.currentLocationId)
    this.CallApi("post", endpoint, data, null,
      (res) => {
        sucFun(res)
      },
      (err) => { errFun(err) })
  }
}
